import * as React from 'react';
import clsx from 'clsx';
import shallowequal from 'shallowequal';
import { Base } from '../../Base';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "ToggleGroup-root_MqYEk",
  "pill": "ToggleGroup-pill_2ytf9"
};
const ensureArray = value => {
  if (Array.isArray(value)) {
    return value;
  }
  if (/string|number/.test(typeof value)) {
    return [value];
  }
  return [];
};
const noop = () => {};
class ToggleGroup extends React.Component {
  static defaultProps = {
    type: 'radio'
  };
  state = {
    values: ensureArray(this.props.value || this.props.defaultValue)
  };
  componentDidUpdate(prevProps) {
    if (this.props.value === prevProps.value) {
      return;
    }
    const arrayValue = ensureArray(this.props.value);
    if (shallowequal(this.state.values, arrayValue)) {
      return;
    }
    this.setState({
      values: arrayValue
    });
  }
  isChecked(value) {
    return this.state.values.indexOf(value) >= 0;
  }
  handleChange(value) {
    const checked = this.isChecked(value);
    const callback = () => {
      if (this.props.handleChange) {
        this.props.handleChange(this.state.values);
      }
    };
    if (this.props.value === undefined) {
      if (this.props.type === 'radio') {
        this.setState({
          values: ensureArray(value)
        }, !checked ? callback : noop);
        return;
      }
      this.setState(prevState => ({
        values: checked ? prevState.values.filter(val => val !== value) : [...prevState.values, value]
      }), callback);
    }
  }
  renderToggle = child => {
    const {
      type,
      name,
      disabled
    } = this.props;
    return /*#__PURE__*/React.cloneElement(child, {
      type,
      disabled,
      tagName: 'label',
      name: child.props.name || name,
      checked: this.isChecked(child.props.value),
      className: clsx(child.props.className, styles.pill),
      onChange: () => this.handleChange(child.props.value)
    });
  };
  renderToggles() {
    return React.Children.toArray(this.props.children).map(this.renderToggle);
  }
  render() {
    const {
      type,
      name,
      legend,
      children,
      defaultValue,
      value,
      disabled,
      onChange,
      handleChange,
      ...extraProps
    } = this.props;
    return /*#__PURE__*/_jsxs(Base, {
      tagName: "fieldset",
      onChange: onChange,
      className: styles.root,
      ...extraProps,
      children: [legend && /*#__PURE__*/_jsx("legend", {
        children: legend
      }), this.renderToggles()]
    });
  }
}
export default ToggleGroup;